import React from 'react';
import { FadeIn, Section } from './ui/Section';
import { FileText, Smartphone, MessageCircle, ListChecks } from 'lucide-react';
export function FeaturesSection() {
  const features = [{
    icon: FileText,
    title: 'PDF Paso a Paso',
    desc: "Guía visual modo 'haz esto ahora' para salir del bloqueo."
  }, {
    icon: Smartphone,
    title: 'Plantilla Editable',
    desc: 'Google Sheets simple para que no empieces de cero.'
  }, {
    icon: ListChecks,
    title: 'Checklist de 7 Días',
    desc: 'Solo 10-15 minutos diarios para retomar el control.'
  }, {
    icon: MessageCircle,
    title: 'Scripts Listos',
    desc: 'Guiones para llamar al banco o cancelar servicios sin vergüenza.'
  }];
  return <Section background="cream-dark" data-id="element-1">
      <FadeIn className="text-center mb-12" data-id="element-2">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#4A3728] mb-4" data-id="element-3">
          ¿Qué incluye exactamente?
        </h2>
        <p className="text-[#6B5D52]" data-id="element-4">
          Todo lo que necesitas para ordenar tu mes en 30 minutos.
        </p>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-5">
        {features.map((feature, idx) => <FadeIn key={idx} delay={idx * 0.1} className="bg-[#FAF7F2] p-6 rounded-xl flex items-start space-x-4 hover:shadow-md transition-shadow duration-300" data-id="element-6">
            <div className="bg-[#E8E2D9] p-3 rounded-lg text-[#4A3728]" data-id="element-7">
              <feature.icon className="w-6 h-6" data-id="element-8" />
            </div>
            <div data-id="element-9">
              <h3 className="font-bold text-[#4A3728] text-lg mb-1" data-id="element-10">
                {feature.title}
              </h3>
              <p className="text-[#6B5D52] text-sm leading-relaxed" data-id="element-11">
                {feature.desc}
              </p>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
}